import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./CustomerTransfers";

const CustomerTransfers = lazy(() => import("./CustomerTransfers"));

export default (props: Props) => (
  <Page>
    <CustomerTransfers {...props} />
  </Page>
);